import { IconSize } from '../Icons/IconWrap';
export const getIconSizeForButtonSize = (buttonSize)=>{
    switch(buttonSize){
        case 'small':
            return IconSize.SMALLER;
        case 'medium':
            return IconSize.SMALLER;
        default:
            return IconSize.MEDIUM;
    }
};
